export enum UserTypeEnum {
  EndUser = 'end-user',
  Admin = 'admin',
}

export enum ProfileTypeEnum {
  Buyer = 'buyer',
  Seller = 'seller',
  Creator = 'creator',
}

export enum UserRoleEnum {
  SuperUser = 'super_user',
  AdminUser = 'admin_user',
  SystemUser = 'system_user',
  BusinessUser = 'business_user',
  MarketingUser = 'marketing_user',
  CustomerSupportUser = 'cust_support_user',
  TechSupportUser = 'tech_support_user',
  ProductUser = 'product_user',
  Client = 'client',
  Official = 'official',
  FirstOrgUser = 'first_org_user',
  Member = 'member',
}

export enum UserRoleIdEnum {
  Client = 1,
  Official = 2,
  FirstOrgUser = 3,
  Member = 4,
  Inspector = 5,
  Buyer = 6,
  Seller = 6,
}

export enum VerifyCredentialTypeEnum {
  Pin = 'PIN',
  Otp = 'OTP',
  Face = 'FACE',
  Fyc = 'FYC',
}

export enum SocialMediaSiteTypeEnum {
  Facebook = 'Facebook',
  Twitter = 'Twitter',
  Instagram = 'Instagram',
  LinkedIn = 'LinkedIn',
  Youtube = 'Youtube',
  Github = 'Github',
  Reddit = 'Reddit',
  Pinterest = 'Pinterest',
  Tumbler = 'Tumbler',
}

export enum PaymentTypeEnum {
  BankAccount = 'BankAccount',
  NetBanking = 'NetBanking',
  Card = 'Card',
  Paypal = 'Paypal',
}

export enum AddressTypeEnum {
  Home = 'Home',
  Office = 'Office',
  Warehouse = 'Warehouse',
  Company = 'Company',
  Factory = 'Factory',
  Others = 'Others',
}

export enum DocumentStatusEnum {
  Pending = 'Pending',
  Verified = 'Verified',
  Rejected = 'Rejected',
}

export enum SellerTypeEnum {
  Individual = 'Individual',
  Company = 'Company',
}

export enum ConsentActionTypesEnum {
  Privacy = 'privacy',
  Age = 'age',
}
